import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Container,
  Row,
} from "reactstrap";
import { Link, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";

import {
  clearBundleCreated,
  clearBundleRemoved,
  clearBundleUpdated,
  getListBundles,
  changeBundleStatusClear,
  clearListBundles,
} from "../../../store/dashboard/Bundles/actions";

import {
  DEFAULT_LIMIT,
  DEFAULT_OFFSET,
} from "../../../constants/pagination";
import Placeholder from "../../../components/Common/Placeholder";
import InfiniteScroll from "../../../components/Common/InfinitScroll";
import useSnackbarState from "../../../hooks/useSnackbarState";
import VideoTableRow from "./components/VideoTableRow";
import withUploadingError from "../../../HOCs/withUploadingError";

import styles from "../dashboard.module.scss";
import SEO from "../../../components/Common/SEO";
import { clearListVideoLibrary, getListVideoLibrary, clearVideoLibraryCreated, clearVideoLibraryUpdated, exportVideoLibraryReport } from '../../../store/dashboard/VideoLibrary/actions';
import videoListStructure from './tableStructure';
import { VIDEOS_LIST_LIMIT } from '../../../constants/paginationConstants';
import useTable from '../../../hooks/useTable';
import Table from "../../../components/Table";
import ScrollbarVertical from "../../../components/Common/ScrollbarVertical";
import VideoLibraryFilters from './filters';
import ConfirmationDialog from '../../../components/Modals/ConfirmationDialog';
import useModal from '../../../hooks/useModal';

const DELETE_MODAL_TITLE = "Export Video Library Report";
const DELETE_MODAL_DESCRIPTION =
  "Are you sure you want to export the video library report, as export process takes a while approx 30 min or more, if you have requested earlier, would recommend to wait for hour or two?";

const VideoLibrary = ({
  clearVideoLibraryCreated,
  videoLibrary,
  getListVideoLibrary,
  clearVideoLibraryUpdated,
  clearListVideoLibrary,
  exportVideoLibraryReport
}) => {
  const { created, updated, removed, changedStatus } = videoLibrary;
  const [modalVisible, toggleModal] = useModal();
  

  // const fetchList = (nextPagination = {}) => {
  //   const { limit = DEFAULT_LIMIT, offset = DEFAULT_OFFSET } = nextPagination;
  //   getListVideoLibrary({ model: { limit, offset } });
  // };

  const { data, pagination, loading, handleTableChange, query } = useTable(
    videoLibrary,
    getListVideoLibrary,
    VIDEOS_LIST_LIMIT
  );

  const [isUpdated] = useSnackbarState(updated, clearVideoLibraryUpdated);
  const [isCreated] = useSnackbarState(created, clearVideoLibraryCreated);

  // const loadMore = useCallback((offset) => fetchList({ offset }), []);

  // useEffect(() => {
  //   // perform effect if entity appears
  //   if (removed) {
  //     fetchList({ limit: DEFAULT_LIMIT, offset: DEFAULT_OFFSET });
  //     // clearVideoLibraryRemoved();
  //   }
  // }, [removed]);

  useEffect(() => {
    // Fetch data
    // fetchList();

    return () => {
      // clearVideoLibraryRemoved();

      clearListVideoLibrary();
    };
  }, []);

  const handleConfirmExportVideoLibraryReport = () => {
    toggleModal();
    exportVideoLibraryReport();
  };

  // useEffect(() => {
  //   if (!loading && !!changedStatus) {
  //     changeVideoLibraryStatusClear();
  //   }
  // }, [changedStatus, loading]);

  return (
    <ScrollbarVertical>
      <ConfirmationDialog
        isOpen={modalVisible}
        titleText={DELETE_MODAL_TITLE}
        contentText={DELETE_MODAL_DESCRIPTION}
        cancelButtonText="Cancel"
        confirmButtonText="Yes"
        onCancel={() => toggleModal()}
        onConfirm={handleConfirmExportVideoLibraryReport}
        altBtnStyle
      />
      <SEO title="Video Library" />
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xs="12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0 font-size-18">VIDEO LIBRARY</h4>
              </div>
            </Col>
          </Row>
          {isCreated && (
            <Row>
              <Col xs="12">
                <Alert color="success">
                  New video has been successfully created
                </Alert>
              </Col>
            </Row>
          )}
          {isUpdated && (
            <Row>
              <Col xs="12">
                <Alert color="success">
                  The video has been successfully updated
                </Alert>
              </Col>
            </Row>
          )}
          <Card className={styles.cardFullsize}>
            <CardBody>
              <CardTitle className="d-flex flex-row justify-content-between">
                <div className={styles.header}>
                </div>

                 
                  <div className='d-flex align-items-start'>
                    <Link to={`/video-library/create`} className="ml-2 mr-2">
                      <Button color="primary" >Create Video</Button>
                    </Link>
                    <div className='d-flex flex-column'>
                      <Button color="secondary" onClick={() => toggleModal()} className='mb-2'>Export Video Library Report</Button>
                      <a rel='noreferrer noopener' href='https://docs.google.com/spreadsheets/d/1zoPwAZWt3G79neDtQ7XkL4eAGmerb3D4f7xd4sZfqeY/edit?gid=0#gid=0' target='_blank'>Video Library Report Link</a>

                    </div>
                  </div>
                  
                
              </CardTitle>
              
            
              <CardText tag={"div"}>
              <Row>
                  <Col xs="12">
                    <Table
                      isRowClick={false}
                      FiltersComponent={VideoLibraryFilters}
                      dataStructure={videoListStructure}
                      data={data}
                      handleTableChange={handleTableChange}
                      totalCount={pagination.totalCount || 0}
                      limit={VIDEOS_LIST_LIMIT}
                      offset={query.offset || 0}
                      loading={loading}
                      rowClickFunc={()=>{}}
                      placeholderText="no videos created"
                    />
                  </Col>
                </Row>
                {/* <Row className="h-100 scrollbar-wrapper">
                  {!loading && !data.length && (
                    <Placeholder text="no videos created" />
                  )}
                  <InfiniteScroll
                    className="w-100 h-100"
                    ref={scrollRef}
                    disabled={data?.length === 0 || loading}
                    offset={pagination.nextOffset}
                    nextOffset={pagination.nextOffset}
                    totalCount={pagination.totalCount}
                    loadMore={loadMore}
                  >
                    {!!data && !!data.length > 0 && (
                      <div className="table-responsive col-12">
                        <Table className="table mt-0 mb-0 border-bottom">
                          <thead className="thead-light">
                            <tr>
                              <th>Video Id</th>
                              <th>Video Title</th>
                              <th>Asset Id</th>
                              <th>Video Tags</th>
                              <th className="w-220px text-right pr-5">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.map((video, index) => (
                              <Fragment key={"table-item-" + index}>
                                <VideoTableRow video={video} />
                              </Fragment>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    )}
                    {loading &&
                      !!data.length &&
                      data.length < pagination.totalCount && (
                        <Col xs={12}>
                          <div className="text-center my-3">
                            <div className="text-success">
                              <i className="bx bx-loader bx-spin font-size-18 align-middle mr-2" />{" "}
                              Load more
                            </div>
                          </div>
                        </Col>
                      )}
                  </InfiniteScroll>
                </Row> */}
              </CardText>
              </CardBody>
              </Card>
        </Container>
      </div>
    </ScrollbarVertical>
  );
};

const mapStateToProps = (state) => {
  const { VideoLibrary } = state;

  return { videoLibrary: VideoLibrary };
};

// Custom comparison function to prevent re-renders
const areEqual = (prevProps, nextProps) => {
  return (
    prevProps.videoLibrary.data === nextProps.videoLibrary.data &&
    prevProps.videoLibrary.loading === nextProps.videoLibrary.loading &&
    prevProps.videoLibrary.created === nextProps.videoLibrary.created &&
    prevProps.videoLibrary.updated === nextProps.videoLibrary.updated
  );
};

export default withUploadingError(
  connect(mapStateToProps, {
    clearVideoLibraryCreated,
    clearVideoLibraryUpdated,
    getListVideoLibrary,
    clearListVideoLibrary,
    exportVideoLibraryReport,
  })(React.memo(VideoLibrary, areEqual))
);
